<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Top Bar, show/hide overlays-->
				<div class="TopBar">
					<!--Buttons-->
					<div>
						<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onRefresh()">Refresh</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSendAlert()">Send Alert</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onSearch()">Search</button>
						<button style="margin-left: 5px" [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onDeselect()">Deselect All</button>
						<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />

						<button
							style="margin-left: 5px"
							[ngClass]="{
								btn: true,
								'btn-success': PlaySounds == true,
								'btn-danger': PlaySounds == false
							}"
							(click)="onPlaySoundsClick()"
						>
							<i *ngIf="PlaySounds == true" class="fa fa-volume-up" aria-hidden="true"></i>
							<i *ngIf="PlaySounds == false" class="fa fa-volume-off" aria-hidden="true"></i>
							{{ PlaySounds == true ? " (Enabled)" : " (Disabled)" }}
						</button>
					</div>

					<!--Info-->
					<div *ngIf="ShowInfo == true" style="margin-top: 10px; margin-bottom: 15px">
						<h4>Top Bar:</h4>
						<div class="InfoBorder">
							<label>Buttons:</label><br />
							<label>&#9900; Send Alert Button: Send alert to selected buses. It will appear on the bus driver's app</label><br />
							<label>&#9900; Search Button: Opens side bar to search for buses or students.</label><br />
							<label>&#9900; Deselect All Button: Deselects all selected items on the map.</label><br />
							<br />
							<label>Overlays (which items/markes to put on the map):</label><br />
							<label>&#9900; Show Buses: When selected displays a bus's current/last known position on the map</label><br />
							<label
								>&#9900; Show Buses From School(s): Select which schools to see data for. NOTE: if the district is hiding data from schools
								you're not assigned to (in the Transit Settings page) then all and my schools will look the same. Also, buses belong to a school
								if they are assigned 1 or more students that go to that school.</label
							><br />
							<label>&#9900; Severity: Show buses that have a certain type of alert.</label><br />
							<label
								>&#9900; Student Gets On Bus: When selected displays where students swiped on the the bus on the map (Only shows today's data.
								Use the Scan History page to see data from previous days.)</label
							><br />
							<label
								>&#9900; Student Gets Off Bus: When selected displays where students swiped off the the bus on the map (Only shows today's data.
								Use the Scan History page to see data from previous days.)</label
							><br />
							<label
								>&#9900; Last Transaction Only: Only shows a student's last transaction and hides the other times they scanned or off a bus. A
								student's last transaction has a * at the end of a label.</label
							><br />
							<label
								>&#9900; Show Students From School(s): Select which schools to see data for. NOTE: if the district is hiding data from schools
								you're not assigned to (in the Transit Settings page) then all and my schools will look the same.</label
							><br />
							<label>&#9900; Show Geo Fences: Shows Geo Fences created on the Geo Fence Maintenance Screen.</label><br />
							<label>&#9900; Hide Inactive Geo Fences: Hides Inactive Geo Fences.</label><br />
							<label
								>&#9900; <span style="color: Red">Hide Unselected</span>: Hides buses and students that aren't selected (items are selected by
								clicking on them or searching for them in the selector). <span style="color: Red">NOTE:</span> Nothing will show up if you
								haven't selected any items in the selector</label
							><br />
							<label>&#9900; Show Traffic: When selected displays google maps traffic data</label><br />
							<label>&#9900; Refresh Seconds: Select how often to refresh the bus and student positions</label><br />
							<br />
							<label>Labels (what text displays next to a bus or student):</label><br />
							<label>&#9900; Bus Number: Displays Bus's number on the map</label><br />
							<label>&#9900; Alert Description: Displays a bus's current alert (if it has one)</label><br />
							<label>&#9900; Student Count: Displays the number of students on a bus (if any)</label><br />
							<label>&#9900; Speed: Displays Bus's current speed</label><br />
							<label
								>&#9900; Speed Alert Mph: Buses show a warning and have a red label if they are going faster than the Speed Alert Mph value. 0
								Disables speed warning</label
							><br />
							<label
								>&#9900; Bus Label Color: Select what color to use for bus labels (Alerts will always have red text.) Reset button sets the
								color to the default value.</label
							><br />
							<label>&#9900; Last Updated: Shows when the bus's position was last updated</label><br />
							<label>&#9900; Student Name: Displays Student's First and Last Name</label><br />
							<label>&#9900; Student ID: Displays Student's ID</label><br />
							<label
								>&#9900; Bus Entered or Exited: Displays the bus that recorded the transaction (which bus the student swiped on or off
								of)</label
							><br />
							<label
								>&#9900; Current Bus(if any): Displays the bus the student is currently on. Displays N/A if the student is at school or at
								home</label
							><br />
							<label>&#9900; Scan Time: Displays the time the student swiped on or off the bus at the marker's location</label><br />
							<label>&#9900; Scheduled Rider: Does the student belong on the bus they go on, or were they added manually?</label><br />
							<label
								>&#9900; Student Label Color: Select what color to use for student labels. Reset button sets the color to the default
								value.</label
							><br />
							<br />
						</div>

						<h4>Selector:</h4>
						<div class="InfoBorder">
							<label>&#9900; Selecting a bus will highlight the bus and the stops it made today.</label><br />
							<label>&#9900; Selecting a student will show all of their transactions today and highlight the current bus they are on.</label
							><br />
							<br />
						</div>

						<h4>Map:</h4>
						<div class="InfoBorder">
							<label>Buses:</label><br />
							<label>&#9900; Right Click: Displays a popup with more info including a list of students on the bus</label><br />
							<label>&#9900; Left Click: Selects the bus. You can then press send alert to send an alert to the selected buses</label><br />
							<label>Bus Colors:</label><br />
							<label>&#9900; Black: Default color. Other colors mean the bus is sending an alert to the school</label><br />
							<label>&#9900; <span style="color: #ff121267">Light Red Bus Window</span>: Low severity alert</label><br />
							<label>&#9900; <span style="color: #ff1212b9">Dark Red Bus Window</span>: Medium severity alert</label><br />
							<label>&#9900; <span style="color: red">Red</span>: High severity alert</label><br />
							<br />
							<label>Students:</label><br />
							<label
								>&#9900; <span style="color: blue">* after a student label</span>: This scan is the student's last transaction (last time they
								got on or off a bus)</label
							><br />
							<label>&#9900; Right Click: Displays a popup with more info</label><br />
							<label
								>&#9900; Left Click: Selects and highlights the student. If there are multiple student entries on the same spot, clicking on
								them will expand them in a spiral so you can see each entry. Pressing ESC or Delete will collapse the spiral</label
							><br />
							<label>&#9900; Students have an ON or OFF label underneath the icon which shows if they got on or off a bus at that stop</label
							><br />
							<br />
							<label>Geo Fence:</label><br />
							<label>&#9900; Maintained on Geo Fence Maintenance Screen</label><br />
							<label>&#9900; Right clicking on one shows more information</label><br />
							<br />
						</div>

						<h4>Tables:</h4>
						<div class="InfoBorder">
							<label>Alerts Sent by School to Buses:</label><br />
							<label>&#9900; List of alerts the school sent to buses.</label><br />
							<label
								>&#9900; <span style="color: red">Inactive</span> means the bus driver has received the message and turned off the alert.</label
							><br />
							<br />
							<label>Alerts Sent by Buses to School:</label><br />
							<label>&#9900; List of alerts the bus driver has sent to the school.</label><br />
							<label>&#9900; Active alerts show up on the map (ex. Bus turns red). Inactive alerts are hidden.</label><br />
							<br />
							<label>Alerts Created by Geo Fences:</label><br />
							<label>&#9900; List of alerts that are created automatically by geofences.</label><br />
							<label
								>&#9900; You can set the trigger type (When a bus enters, when a bus exists, or both) and message from the Geo Fence Maintenance
								screen.</label
							><br />
							<label>&#9900; Active alerts show up on the map (ex. Bus turns red). Inactive alerts are hidden.</label><br />
							<br />
						</div>
					</div>

					<!--Overlays, Labels, etc.-->
					<div class="OptionsFlex">
						<!--Overlays-->
						<div class="OptionsBorder">
							<h5>Overlays:</h5>

							<div class="OptionGrid">
								<div>
									<label>Bus Positions</label>
									<div class="BusOptionGrid">
										<label for="ShowAllBuses">Show Buses:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowAllBuses"
											type="checkbox"
											[(ngModel)]="ShowAllBuses"
											(ngModelChange)="onShowAllBusChange($event)"
										/>

										<label>Show Buses From School(s):</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="BusSchoolOptionID"
											[(ngModel)]="BusSchoolOptionID"
											(ngModelChange)="onBusSchoolOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstBusSchoolOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="BusSchoolOptionID == 2">School:</label>
										<p-dropdown
											*ngIf="BusSchoolOptionID == 2"
											[disabled]="IsLoading() == true"
											[options]="lstSchool"
											[(ngModel)]="BusSchool"
											optionLabel="SchoolFullName"
											[filter]="true"
											filterBy="SchoolFullName"
											[showClear]="false"
											placeholder="Select a School"
											(ngModelChange)="onBusSchoolChange($event)"
										>
											<ng-template pTemplate="selectedItem">
												<div *ngIf="BusSchool">
													<div class="form-control NoBorder" style="text-align: left">
														{{ BusSchool.SchoolFullName }}
													</div>
												</div>
											</ng-template>
											<ng-template let-SchoolItem pTemplate="item">
												<div>
													<div class="form-control NoBorder" style="text-align: left">
														{{ SchoolItem.SchoolFullName }}
													</div>
												</div>
											</ng-template>
										</p-dropdown>

										<label>Severity:</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="BusSeverityOption"
											[(ngModel)]="BusSeverityOption"
											(ngModelChange)="onBusSeverityOptionChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstSeverity" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Positions</label>
									<div class="StudentOptionGrid">
										<label for="StudentSwipeOn">Student Gets On Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="StudentSwipeOn"
											type="checkbox"
											[(ngModel)]="StudentSwipeOn"
											(ngModelChange)="onStudentSwipeOnChange($event)"
										/>

										<label for="StudentSwipeOff">Student Gets Off Bus:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="StudentSwipeOff"
											type="checkbox"
											[(ngModel)]="StudentSwipeOff"
											(ngModelChange)="onStudentSwipeOffChange($event)"
										/>

										<label for="StudentShowLastTransactionOnly">Last Transaction Only:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="StudentShowLastTransactionOnly"
											type="checkbox"
											[(ngModel)]="StudentShowLastTransactionOnly"
											(ngModelChange)="onStudentShowLastTransactionOnlyChange($event)"
										/>

										<!-- <label style="color: Red;">Spiderfy distance TESTING:</label> -->
										<!-- <input [(ngModel)]="Tolerance" type="number" min="0"> -->

										<!-- <label style="color: Red;">DEBUG Spiderfy length:</label>
                                        <input [(ngModel)]="ZoomCoefficient" type="number" min="0" step="0.001"> -->

										<!-- <label>Zoom Level</label>
                                        <label>{{DebugGetZoom()}}</label> -->

										<label>Show Students From School(s):</label>
										<select
											[disabled]="IsLoading() == true"
											class="form-control"
											name="StudentSchoolOptionID"
											[(ngModel)]="StudentSchoolOptionID"
											(ngModelChange)="onStudentSchoolOptionIDChange($event)"
										>
											<option value="" style="display: none"></option>
											<option *ngFor="let o of lstStudentSchoolOption" [ngValue]="o.ID">
												{{ o.Desc }}
											</option>
										</select>

										<label *ngIf="StudentSchoolOptionID == 2">School:</label>
										<p-dropdown
											*ngIf="StudentSchoolOptionID == 2"
											[disabled]="IsLoading() == true"
											[options]="lstSchool"
											[(ngModel)]="StudentSchool"
											optionLabel="SchoolFullName"
											[filter]="true"
											filterBy="SchoolFullName"
											[showClear]="false"
											placeholder="Select a School"
											(ngModelChange)="onStudentSchoolChange($event)"
										>
											<ng-template pTemplate="selectedItem">
												<div *ngIf="StudentSchool">
													<div class="form-control NoBorder" style="text-align: left">
														{{ StudentSchool.SchoolFullName }}
													</div>
												</div>
											</ng-template>
											<ng-template let-SchoolItem pTemplate="item">
												<div>
													<div class="form-control NoBorder" style="text-align: left">
														{{ SchoolItem.SchoolFullName }}
													</div>
												</div>
											</ng-template>
										</p-dropdown>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Geo Fences</label>
									<div class="StudentOptionGrid">
										<label for="ShowGeoFences">Show Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowGeoFences"
											type="checkbox"
											[(ngModel)]="ShowGeoFences"
											(ngModelChange)="onShowGeoFencesChange($event)"
										/>

										<label for="HideInactiveGeoFences">Hide Inactive Geo Fences:</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideInactiveGeoFences"
											type="checkbox"
											[(ngModel)]="HideInactiveGeoFences"
											(ngModelChange)="onHideInactiveGeoFencesChange($event)"
										/>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<div class="MiscOptionGrid">
										<label style="color: Red" for="HideUnselect">Hide Unselected</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="HideUnselect"
											type="checkbox"
											[(ngModel)]="HideUnselect"
											(ngModelChange)="onHideUnselectChange($event)"
										/>

										<label for="ShowTraffic">Show Traffic</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowTraffic"
											type="checkbox"
											[(ngModel)]="ShowTraffic"
											(ngModelChange)="onShowTrafficChange($event)"
										/>

										<label>Refresh Seconds:</label>
										<input class="TextWidth" type="number" [min]="MinimumRefreshSeconds" [(ngModel)]="RefreshMapSeconds" />
									</div>
								</div>
							</div>
						</div>

						<!--Label Options-->
						<div class="OptionsFlexItem OptionsBorder">
							<h5>Labels:</h5>

							<div class="OptionGrid">
								<div>
									<label>Bus Labels</label>
									<div class="BusLabelOptionGrid">
										<label for="ShowBusNumber">Bus Number</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusNumber"
											type="checkbox"
											[(ngModel)]="ShowBusNumber"
											(ngModelChange)="onShowBusNumberChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowAlert">Alert Description</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowAlert"
											type="checkbox"
											[(ngModel)]="ShowAlert"
											(ngModelChange)="onShowAlertChange($event)"
										/>

										<label for="ShowStudentCount">Student Count</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentCount"
											type="checkbox"
											[(ngModel)]="ShowStudentCount"
											(ngModelChange)="onShowStudentCountChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowSpeed">Speed</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowSpeed"
											type="checkbox"
											[(ngModel)]="ShowSpeed"
											(ngModelChange)="onShowSpeedChange($event)"
										/>

										<label for="ShowBusScanTime">Last Updated</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowBusScanTime"
											type="checkbox"
											[(ngModel)]="ShowBusScanTime"
											(ngModelChange)="onShowBusScanTimeChange($event)"
										/>

										<label class="BusLabelMiddelColumn">Speed Alert Mph:</label>
										<input
											[disabled]="IsLoading() == true"
											class="TextWidth"
											type="number"
											[min]="0"
											[(ngModel)]="SpeedAlertMph"
											(ngModelChange)="onSpeedAlertMphChange($event)"
										/>

										<label [style.color]="BusTextColor">Bus Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="BusTextColor"
												(ngModelChange)="onBusTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetBusLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>

								<div class="VerticalBorder"></div>

								<div>
									<label>Student Labels</label>
									<div class="BusLabelOptionGrid">
										<label for="ShowStudentName">Student Name</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentName"
											type="checkbox"
											[(ngModel)]="ShowStudentName"
											(ngModelChange)="onShowStudentNameChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowStudentID">Student ID</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentID"
											type="checkbox"
											[(ngModel)]="ShowStudentID"
											(ngModelChange)="onShowStudentIDChange($event)"
										/>

										<label for="ShowStudentBus">Bus Entered or Exited</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentBus"
											type="checkbox"
											[(ngModel)]="ShowStudentBus"
											(ngModelChange)="onShowStudentBusChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowStudentCurrentBus">Current Bus (if any)</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentCurrentBus"
											type="checkbox"
											[(ngModel)]="ShowStudentCurrentBus"
											(ngModelChange)="onShowStudentCurrentBusChange($event)"
										/>

										<label for="ShowStudentScanTime">Scan Time</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowStudentScanTime"
											type="checkbox"
											[(ngModel)]="ShowStudentScanTime"
											(ngModelChange)="onShowStudentScanTimeChange($event)"
										/>

										<label class="BusLabelMiddelColumn" for="ShowScheduledRider">Scheduled Rider</label>
										<input
											class="CHK"
											[disabled]="IsLoading() == true"
											id="ShowScheduledRider"
											type="checkbox"
											[(ngModel)]="ShowScheduledRider"
											(ngModelChange)="onShowScheduledRiderChange($event)"
										/>

										<label [style.color]="StudentTextColor">Student Label Color:</label>
										<div>
											<p-colorPicker
												[disabled]="IsLoading() == true"
												[(ngModel)]="StudentTextColor"
												(ngModelChange)="onStudentTextColorChange($event)"
												format="hex"
											></p-colorPicker>
											<button [disabled]="IsLoading() == true" class="btn btn-primary ResetButton" (click)="onResetStudentLabelColor()">
												<i class="fa fa-undo" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					[ngClass]="{
						MapGridOneCol: ShowSideBar == false,
						MapGridTwoCol: ShowSideBar == true
					}"
				>
					<p-gmap *ngIf="ShowMap == true" [overlays]="overlays" [options]="options" [style]="{ width: '100%', height: '625px' }"></p-gmap>

					<!--Side Bar for searching for buses or students-->
					<div *ngIf="ShowSideBar == true">
						<caass-bus-selector (SelectedChanged)="onSelectBusesOnMap($event)"> </caass-bus-selector>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
